var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "fixed top-0 left-0 w-screen h-screen bg-slate-200 flex flex-col justify-between",
      style: { zIndex: "1000" }
    },
    [
      _c("div", { attrs: { id: "bulk-container" } }, [
        _c(
          "div",
          {
            staticClass:
              "px-6 h-12 flex-shrink-0 flex items-center bg-pure-white"
          },
          [_c("BlBreadcrumbs", { attrs: { breadcrumbs: _vm.breadcrumbs } })],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "px-6 h-24 flex items-center justify-between gap-6 bg-pure-white border-b border-slate-400",
            attrs: { id: "bulk-header" }
          },
          [
            _c(
              "div",
              { staticClass: "flex flex-col gap-1" },
              [
                _c("BlTextTitle4", {
                  attrs: { text: "Add targets from curricula" }
                }),
                _vm._v(" "),
                _c("BlTextBody2", {
                  attrs: {
                    text:
                      "You can choose multiple curricula from the repository to be added to your client."
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("BlIcon", {
              attrs: { icon: "close", clickable: "" },
              on: {
                clicked: function($event) {
                  return _vm.$emit("close-modal")
                }
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "relative flex overflow-hidden transition-all duration-500",
            style: {
              width: "200vw",
              transform:
                _vm.step === 1 ? "translateX(0vw)" : "translateX(-100vw) "
            },
            attrs: { id: "bulk-body" }
          },
          [
            _c("SelectTargetCurricula", {
              attrs: {
                panelId: _vm.panelId,
                selectedCurriculums: _vm.selectedCurriculums,
                targetTypes: _vm.targetTypes
              },
              on: {
                "open-panel": _vm.onOpenPanel,
                add: _vm.onAdd,
                "add-multi": _vm.onAddMulti,
                remove: _vm.onRemove
              }
            }),
            _vm._v(" "),
            _c("ReviewTargetDatabank", {
              attrs: {
                selectedTargets: _vm.selectedTargets,
                targetTypes: _vm.targetTypes
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "fixed top-36 w-92 flex flex-col justify-between bg-pure-white border border-slate-400 transition-all duration-300 overflow-y-auto",
          class: [_vm.panelOpened ? "right-0" : "-right-92"],
          style: { height: "calc(100vh - 14rem)", zIndex: 51 },
          attrs: { "data-id": _vm.panelId, id: "panel-details" }
        },
        [
          _vm.selectedCurriculum
            ? _c("CurriculaPanelDetails", {
                attrs: {
                  "data-id": _vm.panelId,
                  curriculum: _vm.selectedCurriculum,
                  panelId: _vm.panelId
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.selectedCurriculum
            ? _c(
                "div",
                {
                  staticClass: "sticky bottom-0 z-10 py-5 px-6 bg-pure-white",
                  attrs: { "data-id": _vm.panelId }
                },
                [
                  _c("BlInputButton", {
                    staticClass: "w-full",
                    attrs: {
                      "data-id": _vm.panelId,
                      type: "outlined",
                      disabled: !!_vm.selectedCurriculums.find(function(i) {
                        return i.id === _vm.selectedCurriculum.id
                      }),
                      label: _vm.selectedCurriculums.find(function(i) {
                        return i.id === _vm.selectedCurriculum.id
                      })
                        ? "Added"
                        : "Add Curriculum"
                    },
                    on: {
                      clicked: function($event) {
                        return _vm.onAdd(_vm.selectedCurriculum)
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "sticky bottom-0 z-20 h-20 px-6 flex items-center justify-between border-t border-slate-500 bg-pure-white",
          attrs: { id: "bulk-footer" }
        },
        [
          _c("div", {
            staticClass:
              "white-overlay absolute left-0 bottom-full z-10 h-10 w-screen border-b border-slate-500"
          }),
          _vm._v(" "),
          _c("div", { staticClass: "flex flex-col gap-2" }, [
            _c("div", { staticClass: "flex items-center gap-1" }, [
              _c("div", {
                staticClass: "h-1 w-20 flex-shrink-0 rounded bg-light-purple"
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "h-1 w-20 flex-shrink-0 rounded",
                class: [_vm.step === 2 ? "bg-light-purple" : "bg-slate-400"]
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flex gap-1" }, [
              !_vm.selectedCurriculums.length
                ? _c(
                    "div",
                    {
                      staticClass:
                        "relative h-5 w-5 flex items-center justify-center rounded-full border border-slate-600"
                    },
                    [_c("BlTextSubtitle4", { attrs: { text: "1" } })],
                    1
                  )
                : _c(
                    "div",
                    {
                      staticClass:
                        "relative h-5 w-5 flex items-center justify-center rounded-full border border-success-400"
                    },
                    [
                      _c("BlIcon", {
                        staticClass: "h-6 w-6",
                        attrs: { icon: "check", color: "success-4" }
                      })
                    ],
                    1
                  ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "h-5 flex" },
                [
                  _c("BlTextSubtitle3", {
                    attrs: {
                      text: _vm.step === 1 ? "Add targets" : "Review targets"
                    }
                  })
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex items-center gap-4" },
            [
              _vm.step === 1
                ? _c("BlInputButton", {
                    staticClass: "flex-shrink-0",
                    attrs: {
                      type: "outlined",
                      disabled: !_vm.selectedTargets.length,
                      label:
                        "Next: review " +
                        _vm.selectedTargets.length +
                        " target(s)"
                    },
                    on: {
                      clicked: function($event) {
                        _vm.step = 2
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.step === 2
                ? _c("BlInputButton", {
                    staticClass: "flex-shrink-0",
                    attrs: { type: "outlined", label: "Back" },
                    on: {
                      clicked: function($event) {
                        _vm.step = 1
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.step === 2
                ? _c("BlInputButton", {
                    staticClass: "flex-shrink-0 truncate flex max-w-80",
                    attrs: {
                      loading: _vm.submitLoading,
                      label:
                        "Add " +
                        _vm.selectedTargets.length +
                        " target(s) to " +
                        _vm.client.name
                    },
                    on: { clicked: _vm.onSubmit }
                  })
                : _vm._e()
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4bb50422", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bb50422","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/target/modal/AddTargetFromCurriculaModal.vue
// module id = null
// module chunks = 